import { errorResponse, successResponse } from "../api-interface";
import apiService from "../api-service";

export type Check = {
  check_id: string;
  check_name: string;
  category_id: string;
  category_name: string;
};

export type GetChecksPayload = {
  channel_id: string;
  brand_id: string;
  storyboard: boolean;
  manuscript: boolean;
  figma: boolean;
  brief: boolean;
  role?: string;
  fte_storyboard_type?: string;
};

/**
 * Fetch available QA checks based on brand, channel, and upload requirements
 * @param region - The region (us, de, jp)
 * @param payload - Query parameters for filtering checks
 * @param accessToken - Access token for authentication
 * @returns Array of available checks
 */
export async function getChecksAPI(
  payload: GetChecksPayload,
  accessToken?: string,
) {
  try {
    // Build query parameters from payload
    const queryParams = new URLSearchParams();
    queryParams.append("channel_id", payload.channel_id);
    queryParams.append("brand_id", payload.brand_id);
    queryParams.append("storyboard", String(payload.storyboard));
    queryParams.append("manuscript", String(payload.manuscript));
    queryParams.append("figma", String(payload.figma));
    queryParams.append("brief", String(payload.brief));

    if (payload.role) {
      queryParams.append("role", payload.role);
    }

    if (payload.fte_storyboard_type) {
      queryParams.append("fte_storyboard_type", payload.fte_storyboard_type);
    }

    const url = `/checks?${queryParams.toString()}`;

    const response: any = await apiService.get({
      url,
      baseUrlKey: "apiUrl",
      accessToken,
    });

    if (response?.data) {
      if (Array.isArray(response.data) && response.data.length > 0) {
        return successResponse(response.data);
      } else {
        return errorResponse("No checks available for the selected criteria");
      }
    } else {
      return errorResponse("Failed to fetch checks: network connection issue");
    }
  } catch (error) {
    return errorResponse(
      `Failed to fetch checks: ${error instanceof Error ? error.message : String(error)}`,
    );
  }
}
